// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v3.12.4
// source: brain_msgs.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ChargingInfo, IgnitionInfo, LongitudinalInfo } from "./brain_sensor_msgs";
import { Point, Polygon, Pose, PoseWithCovariance } from "./geometry_msgs";
import { Odometry } from "./nav_msgs";
import { Header } from "./std_msgs";

export const protobufPackage = "brain_msgs.proto";

export interface Message {
  topic: string;
  typeName: string;
  payload: Uint8Array;
}

export interface TurnSignal {
  signal: TurnSignal_Signal;
}

export enum TurnSignal_Signal {
  OFF = 0,
  LEFT = 1,
  RIGHT = 2,
  HAZARD = 3,
  UNRECOGNIZED = -1,
}

export interface AccessoryCmd {
  header: Header | undefined;
  signal: TurnSignal | undefined;
  doorLock: AccessoryCmd_DoorLock;
  doorOpenRight: AccessoryCmd_DoorState;
  doorOpenLeft: AccessoryCmd_DoorState;
}

export enum AccessoryCmd_DoorLock {
  UNLOCK = 0,
  LOCKED = 1,
  UNRECOGNIZED = -1,
}

export enum AccessoryCmd_DoorState {
  INACTIVE = 0,
  CLOSED = 1,
  OPEN = 2,
  UNRECOGNIZED = -1,
}

export interface RegulatoryElement {
  id: number;
  intersectionId: number;
  groupId: number;
  type: RegulatoryElement_Type;
  /** Contains various enum values from original msg */
  subtype: number;
  remainingTime: number;
  refers: Point[];
  refLine: Point[];
  cancels: Point[];
  cancelLine: Point[];
}

export enum RegulatoryElement_Type {
  TRAFFIC_SIGN = 0,
  TRAFFIC_LIGHT = 1,
  SPEED_LIMIT = 2,
  RIGHT_OF_WAY = 3,
  ALL_WAY_STOP = 4,
  UNRECOGNIZED = -1,
}

export enum RegulatoryElement_TrafficSignSubType {
  TRAFFIC_SIGN_UNKNOWN = 0,
  TRAFFIC_SIGN_SCHOOL_ZONE = 1,
  TRAFFIC_SIGN_SPEED_BUMP = 2,
  UNRECOGNIZED = -1,
}

export enum RegulatoryElement_TrafficLightSubType {
  TRAFFIC_LIGHT_UNKNOWN = 0,
  TRAFFIC_LIGHT_RED = 1,
  TRAFFIC_LIGHT_RED_LEFT = 2,
  TRAFFIC_LIGHT_YELLOW = 3,
  TRAFFIC_LIGHT_GREEN = 4,
  TRAFFIC_LIGHT_GREEN_LEFT = 5,
  UNRECOGNIZED = -1,
}

export enum RegulatoryElement_SpeedLimitSubType {
  SPEED_LIMIT_UKNOWN = 0,
  SPEED_LIMIT_5 = 5,
  SPEED_LIMIT_10 = 10,
  SPEED_LIMIT_15 = 15,
  SPEED_LIMIT_20 = 20,
  SPEED_LIMIT_30 = 30,
  SPEED_LIMIT_40 = 40,
  SPEED_LIMIT_50 = 50,
  SPEED_LIMIT_60 = 60,
  SPEED_LIMIT_70 = 70,
  SPEED_LIMIT_80 = 80,
  SPEED_LIMIT_90 = 90,
  SPEED_LIMIT_100 = 100,
  SPEED_LIMIT_110 = 110,
  UNRECOGNIZED = -1,
}

export interface Relation {
  id: number;
  relation: Relation_RelationType;
}

export enum Relation_RelationType {
  UNKNOWN = 0,
  LANE_KEEPING = 1,
  CHANGE_LEFT = 2,
  CHANGE_RIGHT = 3,
  ADJACENT_LEFT = 4,
  ADJACENT_RIGHT = 5,
  CONFLICT = 6,
  AREA = 7,
  UNRECOGNIZED = -1,
}

export interface Area {
  id: number;
  type: Area_Type;
  outer: Polygon | undefined;
  inners: Polygon[];
  regulatoryElements: RegulatoryElement[];
  relationFrom: Relation[];
  relationTo: Relation[];
}

export enum Area_Type {
  UNKNOWN = 0,
  PARKING = 1,
  FREESPACE = 2,
  VEGETATION = 3,
  BUILDING = 4,
  TRAFFIC_ISLAND = 5,
  EXIT = 6,
  SCHOOL_ZONE = 7,
  UNRECOGNIZED = -1,
}

export interface AutonomousMode {
  header: Header | undefined;
  operationMode: AutonomousMode_OperationMode;
  autonomousMode: AutonomousMode_AutoMode;
  errorCode: number;
  warningCode: number;
  activator: AutonomousMode_Activator;
  userDefinedButton0: AutonomousMode_ButtonStatus;
  userDefinedButton1: AutonomousMode_ButtonStatus;
  buttonPushed: AutonomousMode_ButtonStatus;
  mrmStatus: AutonomousMode_MrmStatus;
}

export enum AutonomousMode_OperationMode {
  MANUAL = 0,
  AUTONOMOUS = 1,
  UNRECOGNIZED = -1,
}

export enum AutonomousMode_AutoMode {
  READY = 0,
  RUN = 1,
  PAUSE = 2,
  UNRECOGNIZED = -1,
}

export enum AutonomousMode_Activator {
  ACTIVATOR_UNKNOWN = 0,
  ACTIVATOR_BRAIN = 1,
  ACTIVATOR_REMOTE = 2,
  ACTIVATOR_EXTERNAL_SERVICE = 3,
  UNRECOGNIZED = -1,
}

export enum AutonomousMode_ButtonStatus {
  BUTTON_NA = 0,
  BUTTON_RELEASED = 1,
  BUTTON_PUSHED = 2,
  UNRECOGNIZED = -1,
}

export enum AutonomousMode_MrmStatus {
  MRM_NA = 0,
  MRM_STANDALONE = 1,
  MRM_COOPERATIVE = 2,
  MRM_FAULT = 3,
  UNRECOGNIZED = -1,
}

export interface Gear {
  gear: Gear_GearType;
}

export enum Gear_GearType {
  INACTIVE = 0,
  GEAR_P = 1,
  GEAR_R = 2,
  GEAR_N = 3,
  GEAR_D = 4,
  UNRECOGNIZED = -1,
}

export interface LongitudinalCmd {
  header: Header | undefined;
  mode: LongitudinalCmd_Mode;
  velocity: number;
  acceleration: number;
  torque: number;
  accPos: number;
  accTorque: number;
  brkPos: number;
  brkTorque: number;
  distanceError: number;
  speedError: number;
  gear: Gear | undefined;
}

export enum LongitudinalCmd_Mode {
  INACTIVE = 0,
  MODE_ACCELERATION = 1,
  MODE_TORQUE = 2,
  MODE_PEDAL_POSITION = 3,
  MODE_PEDAL_TORQUE = 4,
  MODE_ACC_POS_BRK_TORQUE = 5,
  MODE_ACC_TORQUE_BRK_POS = 6,
  UNRECOGNIZED = -1,
}

export interface LateralCmd {
  header: Header | undefined;
  mode: LateralCmd_Mode;
  steeringAngle: number;
  steeringAngleRate: number;
  steeringTorque: number;
  torqueLimit: number;
  lateralError: number;
  headingError: number;
}

export enum LateralCmd_Mode {
  INACTIVE = 0,
  ANGLE = 1,
  TORQUE = 2,
  UNRECOGNIZED = -1,
}

export interface CommandRequest {
  header: Header | undefined;
  longitudinalCommand: LongitudinalCmd | undefined;
  lateralCommand: LateralCmd | undefined;
  accessoryCommand: AccessoryCmd | undefined;
}

export interface ConfigCmd {
  header: Header | undefined;
  ecuId: number;
  functionCode: ConfigCmd_FunctionCode;
  targetFunction: number;
  value: number;
}

export enum ConfigCmd_FunctionCode {
  CODE_NA = 0,
  CODE_EXECUTE = 1,
  CODE_GET = 2,
  CODE_SET = 3,
  UNRECOGNIZED = -1,
}

export interface ControlRequest {
  header: Header | undefined;
  controllerId: string;
  requestState: ControlRequest_RequestStatus;
  remoteType: ControlRequest_CtrlType;
}

export enum ControlRequest_RequestStatus {
  REQ_UNKNOWN = 0,
  REQ_INIT = 1,
  REQ_CONFIRM = 2,
  UNRECOGNIZED = -1,
}

export enum ControlRequest_CtrlType {
  CTRL_NONE = 0,
  CTRL_DIRECT = 1,
  CTRL_PROFILE = 2,
  CTRL_WAYPOINT = 3,
  CTRL_SEMANTIC = 4,
  CTRL_EMERGENCY = 5,
  UNRECOGNIZED = -1,
}

export interface ControlStatus {
  header: Header | undefined;
  controllerId: string;
  controlStatus: ControlStatus_Status;
  transferControllerId: string;
  controlTransferStatus: ControlStatus_TransferStatus;
}

export enum ControlStatus_Status {
  STATUS_UNKNOWN = 0,
  STATUS_READY = 1,
  STATUS_OCCUPY = 2,
  STATUS_CONTROL = 3,
  STATUS_DENY = 4,
  UNRECOGNIZED = -1,
}

export enum ControlStatus_TransferStatus {
  TRANSFER_UNKNOWN = 0,
  TRANSFER_WAITING = 1,
  TRANSFER_READY = 2,
  TRANSFER_DENIED = 3,
  UNRECOGNIZED = -1,
}

export interface KeyValue {
  key: string;
  value: string;
  type: KeyValue_Type;
}

export enum KeyValue_Type {
  TYPE_NULL = 0,
  TYPE_BOOL = 1,
  TYPE_INT = 2,
  TYPE_INT64 = 3,
  TYPE_UINT = 4,
  TYPE_UINT64 = 5,
  TYPE_FLOAT = 6,
  TYPE_DOUBLE = 7,
  TYPE_STRING = 8,
  TYPE_BYTES = 9,
  TYPE_TIMESTAMP = 10,
  TYPE_JSON = 11,
  TYPE_XML = 12,
  UNRECOGNIZED = -1,
}

export interface ExternalServiceInfo {
  header: Header | undefined;
  type: ExternalServiceInfo_Type;
  statusCode: number;
  error: boolean;
  warning: boolean;
  states: KeyValue[];
}

export enum ExternalServiceInfo_Type {
  TYPE_UNKNOWN = 0,
  TYPE_PUBLIC_TRANSPORTATION = 1,
  TYPE_POLICE = 2,
  TYPE_AMBULANCE = 3,
  TYPE_ONESITE_RES = 4,
  TYPE_CLEANING_VEHICLE = 5,
  UNRECOGNIZED = -1,
}

export interface Feature {
  header: Header | undefined;
  features: number[];
  type: number;
  /** uint8[] -> bytes */
  dimmension: Uint8Array;
}

export interface FreespacePoint {
  distance: number;
  yaw: number;
  probability: number;
}

export interface Freespace {
  header: Header | undefined;
  type: number;
  resolution: number;
  width: number;
  height: number;
  origin:
    | Pose
    | undefined;
  /** int8[] -> bytes */
  data: Uint8Array;
  points: FreespacePoint[];
  outer: Polygon | undefined;
  inners: Polygon[];
}

export interface KeyValueArray {
  header: Header | undefined;
  uuid: string;
  description: string;
  list: KeyValue[];
}

export interface LanePath {
  path: Relation[];
}

export interface Lanelet {
  id: number;
  type: Lanelet_Type;
  oneWay: boolean;
  leftBoundary: Point[];
  leftBoundaryType: number;
  leftBoundarySubtype: number;
  rightBoundary: Point[];
  rightBoundaryType: number;
  rightBoundarySubtype: number;
  centerLine: Point[];
  regulatoryElements: RegulatoryElement[];
  relationFrom: Relation[];
  relationTo: Relation[];
}

export enum Lanelet_Type {
  UNKNOWN = 0,
  ROAD = 1,
  HIGHWAY = 2,
  PLAY_STREET = 3,
  EMERGENCY_LANE = 4,
  BUS_LANE = 5,
  BICYCLE_LANE = 6,
  WALKWAY = 7,
  SHARED_WALKWAY = 8,
  CROSSWALK = 9,
  STAIRS = 10,
  UNRECOGNIZED = -1,
}

export interface Mission {
  header: Header | undefined;
  mission: Mission_MissionType;
  subMission: string;
}

export enum Mission_MissionType {
  UNKNOWN_MISSION = 0,
  START = 1,
  WAIT_REQUEST = 2,
  DRIVE = 3,
  ABORTED = 4,
  COMPLETE = 5,
  PAUSE = 6,
  UNRECOGNIZED = -1,
}

export interface MissionCmd {
  header: Header | undefined;
  type: MissionCmd_Type;
  subType: string;
}

export enum MissionCmd_Type {
  UNKNOWN = 0,
  START_MISSION = 1,
  COMPLETE_MISSION = 2,
  CLEAR_MISSION = 3,
  ABORT_MISSION = 4,
  RECOVER_MISSION = 5,
  FAIL_MISSION = 6,
  PAUSE_MISSION = 7,
  RESUME_MISSION = 8,
  CANCEL_MISSION = 9,
  UNRECOGNIZED = -1,
}

export interface MrmCmd {
  header: Header | undefined;
  mode: MrmCmd_Mode;
  warningLevel: number;
}

export enum MrmCmd_Mode {
  MRM_NA = 0,
  MRM_MIDLEVEL_LAT = 1,
  MRM_MIDLEVEL_LON = 2,
  MRM_MIDLEVEL_ESTOP = 3,
  MRM_MIDLEVEL = 4,
  MRM_LOWLEVEL = 5,
  MRM_HIGHLEVEL_STOP_LANE = 6,
  MRM_HIGHLEVEL_STOP_SIDE = 7,
  MRM_HIGHLEVEL_KEEP_LANE = 8,
  UNRECOGNIZED = -1,
}

export interface MultiFunctionSwitch {
  mfs: MultiFunctionSwitch_Mfs;
}

export enum MultiFunctionSwitch_Mfs {
  OFF = 0,
  LEFT = 1,
  RIGHT = 2,
  UNRECOGNIZED = -1,
}

export interface Size {
  header: Header | undefined;
  size: number[];
  type: Size_Type;
}

export enum Size_Type {
  UNKNOWN = 0,
  RECTANGLE = 1,
  CIRCLE = 2,
  UNRECOGNIZED = -1,
}

export interface Track {
  header: Header | undefined;
  id: number;
  state: number[];
  stateDescriptor: string[];
  covariance: number[];
  /** Simplified from 'time' */
  initialTime:
    | Header
    | undefined;
  /** Simplified from 'time' */
  updateTime: Header | undefined;
  updateCount: number;
  gate: number[];
  status: number;
  model: number;
}

export interface Object {
  header: Header | undefined;
  odometry: Odometry | undefined;
  anchor: Odometry | undefined;
  size: Size | undefined;
  polygon: Polygon | undefined;
  track: Track | undefined;
  tracklet: Odometry[];
  classification: Object_Classification;
  level: Object_Level;
  sensor: number;
  motionState: Object_MotionState;
  stopCount: number;
  intent: Object_Intent;
  geometry: Point[];
  feature: Feature | undefined;
}

export enum Object_Classification {
  UNKNOWN = 0,
  UNKNOWN_SMALL = 1,
  UNKNOWN_MEDIUM = 2,
  UNKNOWN_BIG = 3,
  PEDESTRIAN = 4,
  BIKE = 5,
  CAR = 6,
  TRUCK = 7,
  MOTORCYCLE = 8,
  OTHER_VEHICLE = 9,
  BARRIER = 10,
  SIGN = 11,
  UNRECOGNIZED = -1,
}

export enum Object_Level {
  /** LEVEL_UNKNOWN - Renamed to avoid conflict */
  LEVEL_UNKNOWN = 0,
  DETECTED = 1,
  TRACKED = 2,
  FUSED = 3,
  PREDICTED = 4,
  UNRECOGNIZED = -1,
}

export enum Object_MotionState {
  /** MOTION_STATE_UNKNOWN - Renamed */
  MOTION_STATE_UNKNOWN = 0,
  STOP = 1,
  STATIONARY = 2,
  MOVING = 3,
  UNRECOGNIZED = -1,
}

export enum Object_Intent {
  /** INTENT_UNKNOWN - Renamed */
  INTENT_UNKNOWN = 0,
  INTENT_STOP = 1,
  INTENT_STATIONARY = 2,
  INTENT_MOVING = 3,
  CHANGE_LANE = 4,
  LOW_ACCELERATION = 5,
  HIGH_ACCELERATION = 6,
  LOW_DECELERATION = 7,
  HIGH_DECELERATION = 8,
  UNRECOGNIZED = -1,
}

export interface ObjectArray {
  header: Header | undefined;
  objects: Object[];
}

export interface OperationSw {
  header: Header | undefined;
  operationSw: boolean;
  autonomousSw: boolean;
  emergencySw: boolean;
  activator: OperationSw_Activator;
}

export enum OperationSw_Activator {
  ACTIVATOR_UNKNOWN = 0,
  ACTIVATOR_BRAIN = 1,
  ACTIVATOR_REMOTE = 2,
  ACTIVATOR_EXTERNAL_SERVICE = 3,
  UNRECOGNIZED = -1,
}

export interface PathNode {
  pose: Pose | undefined;
  dir: number;
}

export interface Path {
  header: Header | undefined;
  nodes: PathNode[];
  behavior: Path_Behavior;
  subtype: Path_Subtype;
  state: Path_State;
}

export enum Path_Behavior {
  UNKNOWN = 0,
  ONROAD = 1,
  PARKING = 2,
  EMERGENCY = 3,
  UNRECOGNIZED = -1,
}

export enum Path_Subtype {
  /** LANE_KEEPING - Default */
  LANE_KEEPING = 0,
  LANE_KEEPING_LEFT_TURN = 2,
  LANE_KEEPING_RIGHT_TURN = 3,
  LANE_KEEPING_U_TURN = 4,
  CHANGE_LEFT = 5,
  CHANGE_RIGHT = 6,
  APPROACHING_PARKING = 7,
  PERPENDICULAR_PARKING = 8,
  PARALLEL_PARKING = 9,
  ANGULAR_PARKING = 10,
  PULL_OVER = 11,
  RETURN_TO_LANE = 12,
  PULL_OVER_AND_STOP = 13,
  IN_LANE_STOP = 14,
  UNRECOGNIZED = -1,
}

export enum Path_State {
  READY = 0,
  ONGOING = 1,
  COMPLETE = 2,
  UNRECOGNIZED = -1,
}

export interface Route {
  route: Relation[];
}

export interface Road {
  header: Header | undefined;
  route: Route | undefined;
  path: LanePath | undefined;
  lanes: Lanelet[];
  areas: Area[];
  goal: Pose | undefined;
}

export interface SpeedProfileNode {
  distance: number;
  speed: number;
  time: number;
  direction: number;
}

export interface SpeedProfile {
  header: Header | undefined;
  speedLimit: number;
  points: SpeedProfileNode[];
  stopLine: Point[];
}

export interface SystemCmd {
  header: Header | undefined;
  command: SystemCmd_Command;
}

export enum SystemCmd_Command {
  COMMAND_NA = 0,
  COMMAND_RESET = 1,
  COMMAND_START = 2,
  COMMAND_PAUSE = 3,
  COMMAND_STOP = 4,
  COMMAND_ESTOP = 5,
  UNRECOGNIZED = -1,
}

export interface TextNotify {
  header: Header | undefined;
  uuid: string;
  author: string;
  createdAt: string;
  title: string;
  text: string;
  format: TextNotify_Format;
  urgentLevel: TextNotify_UrgentLevel;
}

export enum TextNotify_Format {
  FORMAT_TXT = 0,
  FORMAT_JSON = 1,
  FORMAT_MARKDOWN = 2,
  FORMAT_HTML = 3,
  UNRECOGNIZED = -1,
}

export enum TextNotify_UrgentLevel {
  LEVEL_NA = 0,
  LEVEL_INFO = 1,
  LEVEL_WARNING = 2,
  LEVEL_ERROR = 3,
  LEVEL_CRITICAL = 4,
  UNRECOGNIZED = -1,
}

export interface TrafficLight {
  header: Header | undefined;
  state: TrafficLight_State;
  stateProbability: number;
  type: TrafficLight_Type;
  isIts: boolean;
  intersectionId: number;
  groupId: number;
  endTime: number;
  level: TrafficLight_Level;
  trackId: number;
  pose: PoseWithCovariance | undefined;
}

export enum TrafficLight_State {
  UNKNOWN = 0,
  RED = 1,
  YELLOW = 2,
  GREEN = 3,
  GREEN_LEFT = 4,
  RED_LEFT = 5,
  UNRECOGNIZED = -1,
}

export enum TrafficLight_Type {
  /** TYPE_UNKNOWN - Renamed */
  TYPE_UNKNOWN = 0,
  STR = 1,
  LEFT = 2,
  PED = 3,
  UTURN = 4,
  UNRECOGNIZED = -1,
}

export enum TrafficLight_Level {
  /** LEVEL_UNKNOWN - Renamed */
  LEVEL_UNKNOWN = 0,
  DETECTED = 1,
  TRACKED = 2,
  FUSED = 3,
  PREDICTED = 4,
  UNRECOGNIZED = -1,
}

export interface TrafficLightArray {
  header: Header | undefined;
  trafficLights: TrafficLight[];
}

export interface Wgs84 {
  latitude: number;
  longitude: number;
  height: number;
  heading: number;
  status: Wgs84_Status;
}

export enum Wgs84_Status {
  VALID = 0,
  INVALID = 1,
  UNRECOGNIZED = -1,
}

export interface VehicleResponse {
  header: Header | undefined;
  response: VehicleResponse_Response;
  gnss: Wgs84 | undefined;
}

export enum VehicleResponse_Response {
  UNKNOWN = 0,
  READY = 1,
  WAITING = 2,
  DRIVING = 3,
  PARKING = 4,
  COMPLETE = 5,
  UNRECOGNIZED = -1,
}

export interface VehicleState {
  header: Header | undefined;
  odometry: Odometry | undefined;
  gnss: Wgs84 | undefined;
  reference: Wgs84 | undefined;
  speed: number;
  longitudinalAcceleration: number;
  lateralAcceleration: number;
  steeringAngle: number;
  gear: Gear | undefined;
  turnSignal: TurnSignal | undefined;
  mfs: MultiFunctionSwitch | undefined;
  ignition: IgnitionInfo | undefined;
  charging: ChargingInfo | undefined;
  pedal: LongitudinalInfo | undefined;
}

export interface Waypoint {
  header: Header | undefined;
  point: Wgs84 | undefined;
}

export interface Waypoints {
  header: Header | undefined;
  numPoints: number;
  points: Waypoint[];
}

/** This was an empty message, so it remains empty. */
export interface BrainStatus {
}

export interface ChargingCmd {
  header: Header | undefined;
  doorCmd: ChargingCmd_ChargingDoorCmd;
}

export enum ChargingCmd_ChargingDoorCmd {
  CHARGHING_DOOR_HOLD = 0,
  CHARGHING_DOOR_CLOSE = 1,
  CHARGHING_DOOR_OPEN = 2,
  UNRECOGNIZED = -1,
}

export interface IgnitionCmd {
  header: Header | undefined;
  request: IgnitionCmd_IgState;
}

export enum IgnitionCmd_IgState {
  IG_UNKNOWN = 0,
  IG_OFF = 1,
  IG_ACCESSORY = 2,
  IG_START = 3,
  IG_DRIVE = 4,
  UNRECOGNIZED = -1,
}

export interface CanFrame {
  header: Header | undefined;
  channel: string;
  description: string;
  /** CAN ID (11-bit 또는 29-bit) */
  id: number;
  /** Extended ID 여부 (29-bit) */
  isExtended: boolean;
  /** CAN FD 포맷 여부 */
  isFd: boolean;
  /** Remote Transmission Request (RTR) 여부 */
  isRemote: boolean;
  /** Error Frame 여부 */
  isError: boolean;
  /** CAN FD 전용 플래그 */
  brs: boolean;
  /** Error State Indicator */
  esi: boolean;
  /** Data Length Code (0~15) */
  dlc: number;
  /** 실제 페이로드 (CAN: 최대 8, CAN FD: 최대 64 bytes) */
  data: Uint8Array;
}

export interface EthernetPacket {
  header:
    | Header
    | undefined;
  /** 예: "eth0", "enp0s3" */
  interfaceName: string;
  /** 소스 MAC 주소 */
  srcMac: Uint8Array;
  /** 목적지 MAC 주소 */
  dstMac: Uint8Array;
  /** EtherType (IPv4: 0x0800, ARP: 0x0806 등) */
  etherType: number;
  /** L3 이상 데이터 (IP Packet 등) */
  payload: Uint8Array;
  /** VLAN Tagging이 필요한 경우 (옵션) */
  vlanId: number;
}

function createBaseMessage(): Message {
  return { topic: "", typeName: "", payload: new Uint8Array(0) };
}

export const Message: MessageFns<Message> = {
  encode(message: Message, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.topic !== "") {
      writer.uint32(10).string(message.topic);
    }
    if (message.typeName !== "") {
      writer.uint32(18).string(message.typeName);
    }
    if (message.payload.length !== 0) {
      writer.uint32(26).bytes(message.payload);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Message {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.topic = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.typeName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.payload = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Message>, I>>(base?: I): Message {
    return Message.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Message>, I>>(object: I): Message {
    const message = createBaseMessage();
    message.topic = object.topic ?? "";
    message.typeName = object.typeName ?? "";
    message.payload = object.payload ?? new Uint8Array(0);
    return message;
  },
};

function createBaseTurnSignal(): TurnSignal {
  return { signal: 0 };
}

export const TurnSignal: MessageFns<TurnSignal> = {
  encode(message: TurnSignal, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.signal !== 0) {
      writer.uint32(8).int32(message.signal);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TurnSignal {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTurnSignal();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.signal = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TurnSignal>, I>>(base?: I): TurnSignal {
    return TurnSignal.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TurnSignal>, I>>(object: I): TurnSignal {
    const message = createBaseTurnSignal();
    message.signal = object.signal ?? 0;
    return message;
  },
};

function createBaseAccessoryCmd(): AccessoryCmd {
  return { header: undefined, signal: undefined, doorLock: 0, doorOpenRight: 0, doorOpenLeft: 0 };
}

export const AccessoryCmd: MessageFns<AccessoryCmd> = {
  encode(message: AccessoryCmd, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.signal !== undefined) {
      TurnSignal.encode(message.signal, writer.uint32(18).fork()).join();
    }
    if (message.doorLock !== 0) {
      writer.uint32(24).int32(message.doorLock);
    }
    if (message.doorOpenRight !== 0) {
      writer.uint32(32).int32(message.doorOpenRight);
    }
    if (message.doorOpenLeft !== 0) {
      writer.uint32(40).int32(message.doorOpenLeft);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccessoryCmd {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccessoryCmd();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.signal = TurnSignal.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.doorLock = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.doorOpenRight = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.doorOpenLeft = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<AccessoryCmd>, I>>(base?: I): AccessoryCmd {
    return AccessoryCmd.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AccessoryCmd>, I>>(object: I): AccessoryCmd {
    const message = createBaseAccessoryCmd();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.signal = (object.signal !== undefined && object.signal !== null)
      ? TurnSignal.fromPartial(object.signal)
      : undefined;
    message.doorLock = object.doorLock ?? 0;
    message.doorOpenRight = object.doorOpenRight ?? 0;
    message.doorOpenLeft = object.doorOpenLeft ?? 0;
    return message;
  },
};

function createBaseRegulatoryElement(): RegulatoryElement {
  return {
    id: 0,
    intersectionId: 0,
    groupId: 0,
    type: 0,
    subtype: 0,
    remainingTime: 0,
    refers: [],
    refLine: [],
    cancels: [],
    cancelLine: [],
  };
}

export const RegulatoryElement: MessageFns<RegulatoryElement> = {
  encode(message: RegulatoryElement, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.intersectionId !== 0) {
      writer.uint32(16).int64(message.intersectionId);
    }
    if (message.groupId !== 0) {
      writer.uint32(24).int64(message.groupId);
    }
    if (message.type !== 0) {
      writer.uint32(32).int32(message.type);
    }
    if (message.subtype !== 0) {
      writer.uint32(40).uint32(message.subtype);
    }
    if (message.remainingTime !== 0) {
      writer.uint32(53).float(message.remainingTime);
    }
    for (const v of message.refers) {
      Point.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.refLine) {
      Point.encode(v!, writer.uint32(66).fork()).join();
    }
    for (const v of message.cancels) {
      Point.encode(v!, writer.uint32(74).fork()).join();
    }
    for (const v of message.cancelLine) {
      Point.encode(v!, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RegulatoryElement {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegulatoryElement();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.intersectionId = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.groupId = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.subtype = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.remainingTime = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.refers.push(Point.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.refLine.push(Point.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.cancels.push(Point.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.cancelLine.push(Point.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RegulatoryElement>, I>>(base?: I): RegulatoryElement {
    return RegulatoryElement.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegulatoryElement>, I>>(object: I): RegulatoryElement {
    const message = createBaseRegulatoryElement();
    message.id = object.id ?? 0;
    message.intersectionId = object.intersectionId ?? 0;
    message.groupId = object.groupId ?? 0;
    message.type = object.type ?? 0;
    message.subtype = object.subtype ?? 0;
    message.remainingTime = object.remainingTime ?? 0;
    message.refers = object.refers?.map((e) => Point.fromPartial(e)) || [];
    message.refLine = object.refLine?.map((e) => Point.fromPartial(e)) || [];
    message.cancels = object.cancels?.map((e) => Point.fromPartial(e)) || [];
    message.cancelLine = object.cancelLine?.map((e) => Point.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRelation(): Relation {
  return { id: 0, relation: 0 };
}

export const Relation: MessageFns<Relation> = {
  encode(message: Relation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.relation !== 0) {
      writer.uint32(16).int32(message.relation);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Relation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRelation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.relation = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Relation>, I>>(base?: I): Relation {
    return Relation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Relation>, I>>(object: I): Relation {
    const message = createBaseRelation();
    message.id = object.id ?? 0;
    message.relation = object.relation ?? 0;
    return message;
  },
};

function createBaseArea(): Area {
  return { id: 0, type: 0, outer: undefined, inners: [], regulatoryElements: [], relationFrom: [], relationTo: [] };
}

export const Area: MessageFns<Area> = {
  encode(message: Area, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    if (message.outer !== undefined) {
      Polygon.encode(message.outer, writer.uint32(26).fork()).join();
    }
    for (const v of message.inners) {
      Polygon.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.regulatoryElements) {
      RegulatoryElement.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.relationFrom) {
      Relation.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.relationTo) {
      Relation.encode(v!, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Area {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArea();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.outer = Polygon.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.inners.push(Polygon.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.regulatoryElements.push(RegulatoryElement.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.relationFrom.push(Relation.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.relationTo.push(Relation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Area>, I>>(base?: I): Area {
    return Area.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Area>, I>>(object: I): Area {
    const message = createBaseArea();
    message.id = object.id ?? 0;
    message.type = object.type ?? 0;
    message.outer = (object.outer !== undefined && object.outer !== null)
      ? Polygon.fromPartial(object.outer)
      : undefined;
    message.inners = object.inners?.map((e) => Polygon.fromPartial(e)) || [];
    message.regulatoryElements = object.regulatoryElements?.map((e) => RegulatoryElement.fromPartial(e)) || [];
    message.relationFrom = object.relationFrom?.map((e) => Relation.fromPartial(e)) || [];
    message.relationTo = object.relationTo?.map((e) => Relation.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAutonomousMode(): AutonomousMode {
  return {
    header: undefined,
    operationMode: 0,
    autonomousMode: 0,
    errorCode: 0,
    warningCode: 0,
    activator: 0,
    userDefinedButton0: 0,
    userDefinedButton1: 0,
    buttonPushed: 0,
    mrmStatus: 0,
  };
}

export const AutonomousMode: MessageFns<AutonomousMode> = {
  encode(message: AutonomousMode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.operationMode !== 0) {
      writer.uint32(16).int32(message.operationMode);
    }
    if (message.autonomousMode !== 0) {
      writer.uint32(24).int32(message.autonomousMode);
    }
    if (message.errorCode !== 0) {
      writer.uint32(32).uint32(message.errorCode);
    }
    if (message.warningCode !== 0) {
      writer.uint32(40).uint32(message.warningCode);
    }
    if (message.activator !== 0) {
      writer.uint32(48).int32(message.activator);
    }
    if (message.userDefinedButton0 !== 0) {
      writer.uint32(56).int32(message.userDefinedButton0);
    }
    if (message.userDefinedButton1 !== 0) {
      writer.uint32(64).int32(message.userDefinedButton1);
    }
    if (message.buttonPushed !== 0) {
      writer.uint32(72).int32(message.buttonPushed);
    }
    if (message.mrmStatus !== 0) {
      writer.uint32(80).int32(message.mrmStatus);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AutonomousMode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAutonomousMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.operationMode = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.autonomousMode = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.errorCode = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.warningCode = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.activator = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.userDefinedButton0 = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.userDefinedButton1 = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.buttonPushed = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.mrmStatus = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<AutonomousMode>, I>>(base?: I): AutonomousMode {
    return AutonomousMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AutonomousMode>, I>>(object: I): AutonomousMode {
    const message = createBaseAutonomousMode();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.operationMode = object.operationMode ?? 0;
    message.autonomousMode = object.autonomousMode ?? 0;
    message.errorCode = object.errorCode ?? 0;
    message.warningCode = object.warningCode ?? 0;
    message.activator = object.activator ?? 0;
    message.userDefinedButton0 = object.userDefinedButton0 ?? 0;
    message.userDefinedButton1 = object.userDefinedButton1 ?? 0;
    message.buttonPushed = object.buttonPushed ?? 0;
    message.mrmStatus = object.mrmStatus ?? 0;
    return message;
  },
};

function createBaseGear(): Gear {
  return { gear: 0 };
}

export const Gear: MessageFns<Gear> = {
  encode(message: Gear, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.gear !== 0) {
      writer.uint32(8).int32(message.gear);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Gear {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGear();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.gear = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Gear>, I>>(base?: I): Gear {
    return Gear.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Gear>, I>>(object: I): Gear {
    const message = createBaseGear();
    message.gear = object.gear ?? 0;
    return message;
  },
};

function createBaseLongitudinalCmd(): LongitudinalCmd {
  return {
    header: undefined,
    mode: 0,
    velocity: 0,
    acceleration: 0,
    torque: 0,
    accPos: 0,
    accTorque: 0,
    brkPos: 0,
    brkTorque: 0,
    distanceError: 0,
    speedError: 0,
    gear: undefined,
  };
}

export const LongitudinalCmd: MessageFns<LongitudinalCmd> = {
  encode(message: LongitudinalCmd, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.mode !== 0) {
      writer.uint32(16).int32(message.mode);
    }
    if (message.velocity !== 0) {
      writer.uint32(29).float(message.velocity);
    }
    if (message.acceleration !== 0) {
      writer.uint32(37).float(message.acceleration);
    }
    if (message.torque !== 0) {
      writer.uint32(45).float(message.torque);
    }
    if (message.accPos !== 0) {
      writer.uint32(53).float(message.accPos);
    }
    if (message.accTorque !== 0) {
      writer.uint32(61).float(message.accTorque);
    }
    if (message.brkPos !== 0) {
      writer.uint32(69).float(message.brkPos);
    }
    if (message.brkTorque !== 0) {
      writer.uint32(77).float(message.brkTorque);
    }
    if (message.distanceError !== 0) {
      writer.uint32(85).float(message.distanceError);
    }
    if (message.speedError !== 0) {
      writer.uint32(93).float(message.speedError);
    }
    if (message.gear !== undefined) {
      Gear.encode(message.gear, writer.uint32(98).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LongitudinalCmd {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLongitudinalCmd();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.velocity = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.acceleration = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.torque = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.accPos = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.accTorque = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.brkPos = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.brkTorque = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.distanceError = reader.float();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.speedError = reader.float();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.gear = Gear.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<LongitudinalCmd>, I>>(base?: I): LongitudinalCmd {
    return LongitudinalCmd.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LongitudinalCmd>, I>>(object: I): LongitudinalCmd {
    const message = createBaseLongitudinalCmd();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.mode = object.mode ?? 0;
    message.velocity = object.velocity ?? 0;
    message.acceleration = object.acceleration ?? 0;
    message.torque = object.torque ?? 0;
    message.accPos = object.accPos ?? 0;
    message.accTorque = object.accTorque ?? 0;
    message.brkPos = object.brkPos ?? 0;
    message.brkTorque = object.brkTorque ?? 0;
    message.distanceError = object.distanceError ?? 0;
    message.speedError = object.speedError ?? 0;
    message.gear = (object.gear !== undefined && object.gear !== null) ? Gear.fromPartial(object.gear) : undefined;
    return message;
  },
};

function createBaseLateralCmd(): LateralCmd {
  return {
    header: undefined,
    mode: 0,
    steeringAngle: 0,
    steeringAngleRate: 0,
    steeringTorque: 0,
    torqueLimit: 0,
    lateralError: 0,
    headingError: 0,
  };
}

export const LateralCmd: MessageFns<LateralCmd> = {
  encode(message: LateralCmd, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.mode !== 0) {
      writer.uint32(16).int32(message.mode);
    }
    if (message.steeringAngle !== 0) {
      writer.uint32(29).float(message.steeringAngle);
    }
    if (message.steeringAngleRate !== 0) {
      writer.uint32(37).float(message.steeringAngleRate);
    }
    if (message.steeringTorque !== 0) {
      writer.uint32(45).float(message.steeringTorque);
    }
    if (message.torqueLimit !== 0) {
      writer.uint32(53).float(message.torqueLimit);
    }
    if (message.lateralError !== 0) {
      writer.uint32(61).float(message.lateralError);
    }
    if (message.headingError !== 0) {
      writer.uint32(69).float(message.headingError);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LateralCmd {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLateralCmd();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.steeringAngle = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.steeringAngleRate = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.steeringTorque = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.torqueLimit = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.lateralError = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.headingError = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<LateralCmd>, I>>(base?: I): LateralCmd {
    return LateralCmd.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LateralCmd>, I>>(object: I): LateralCmd {
    const message = createBaseLateralCmd();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.mode = object.mode ?? 0;
    message.steeringAngle = object.steeringAngle ?? 0;
    message.steeringAngleRate = object.steeringAngleRate ?? 0;
    message.steeringTorque = object.steeringTorque ?? 0;
    message.torqueLimit = object.torqueLimit ?? 0;
    message.lateralError = object.lateralError ?? 0;
    message.headingError = object.headingError ?? 0;
    return message;
  },
};

function createBaseCommandRequest(): CommandRequest {
  return { header: undefined, longitudinalCommand: undefined, lateralCommand: undefined, accessoryCommand: undefined };
}

export const CommandRequest: MessageFns<CommandRequest> = {
  encode(message: CommandRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.longitudinalCommand !== undefined) {
      LongitudinalCmd.encode(message.longitudinalCommand, writer.uint32(18).fork()).join();
    }
    if (message.lateralCommand !== undefined) {
      LateralCmd.encode(message.lateralCommand, writer.uint32(26).fork()).join();
    }
    if (message.accessoryCommand !== undefined) {
      AccessoryCmd.encode(message.accessoryCommand, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommandRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommandRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.longitudinalCommand = LongitudinalCmd.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.lateralCommand = LateralCmd.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.accessoryCommand = AccessoryCmd.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CommandRequest>, I>>(base?: I): CommandRequest {
    return CommandRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommandRequest>, I>>(object: I): CommandRequest {
    const message = createBaseCommandRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.longitudinalCommand = (object.longitudinalCommand !== undefined && object.longitudinalCommand !== null)
      ? LongitudinalCmd.fromPartial(object.longitudinalCommand)
      : undefined;
    message.lateralCommand = (object.lateralCommand !== undefined && object.lateralCommand !== null)
      ? LateralCmd.fromPartial(object.lateralCommand)
      : undefined;
    message.accessoryCommand = (object.accessoryCommand !== undefined && object.accessoryCommand !== null)
      ? AccessoryCmd.fromPartial(object.accessoryCommand)
      : undefined;
    return message;
  },
};

function createBaseConfigCmd(): ConfigCmd {
  return { header: undefined, ecuId: 0, functionCode: 0, targetFunction: 0, value: 0 };
}

export const ConfigCmd: MessageFns<ConfigCmd> = {
  encode(message: ConfigCmd, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.ecuId !== 0) {
      writer.uint32(16).uint32(message.ecuId);
    }
    if (message.functionCode !== 0) {
      writer.uint32(24).int32(message.functionCode);
    }
    if (message.targetFunction !== 0) {
      writer.uint32(32).uint32(message.targetFunction);
    }
    if (message.value !== 0) {
      writer.uint32(45).float(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfigCmd {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigCmd();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.ecuId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.functionCode = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.targetFunction = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.value = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ConfigCmd>, I>>(base?: I): ConfigCmd {
    return ConfigCmd.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConfigCmd>, I>>(object: I): ConfigCmd {
    const message = createBaseConfigCmd();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.ecuId = object.ecuId ?? 0;
    message.functionCode = object.functionCode ?? 0;
    message.targetFunction = object.targetFunction ?? 0;
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseControlRequest(): ControlRequest {
  return { header: undefined, controllerId: "", requestState: 0, remoteType: 0 };
}

export const ControlRequest: MessageFns<ControlRequest> = {
  encode(message: ControlRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.controllerId !== "") {
      writer.uint32(18).string(message.controllerId);
    }
    if (message.requestState !== 0) {
      writer.uint32(24).int32(message.requestState);
    }
    if (message.remoteType !== 0) {
      writer.uint32(32).int32(message.remoteType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ControlRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseControlRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.controllerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.requestState = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.remoteType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ControlRequest>, I>>(base?: I): ControlRequest {
    return ControlRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ControlRequest>, I>>(object: I): ControlRequest {
    const message = createBaseControlRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.controllerId = object.controllerId ?? "";
    message.requestState = object.requestState ?? 0;
    message.remoteType = object.remoteType ?? 0;
    return message;
  },
};

function createBaseControlStatus(): ControlStatus {
  return { header: undefined, controllerId: "", controlStatus: 0, transferControllerId: "", controlTransferStatus: 0 };
}

export const ControlStatus: MessageFns<ControlStatus> = {
  encode(message: ControlStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.controllerId !== "") {
      writer.uint32(18).string(message.controllerId);
    }
    if (message.controlStatus !== 0) {
      writer.uint32(24).int32(message.controlStatus);
    }
    if (message.transferControllerId !== "") {
      writer.uint32(34).string(message.transferControllerId);
    }
    if (message.controlTransferStatus !== 0) {
      writer.uint32(40).int32(message.controlTransferStatus);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ControlStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseControlStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.controllerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.controlStatus = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.transferControllerId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.controlTransferStatus = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ControlStatus>, I>>(base?: I): ControlStatus {
    return ControlStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ControlStatus>, I>>(object: I): ControlStatus {
    const message = createBaseControlStatus();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.controllerId = object.controllerId ?? "";
    message.controlStatus = object.controlStatus ?? 0;
    message.transferControllerId = object.transferControllerId ?? "";
    message.controlTransferStatus = object.controlTransferStatus ?? 0;
    return message;
  },
};

function createBaseKeyValue(): KeyValue {
  return { key: "", value: "", type: 0 };
}

export const KeyValue: MessageFns<KeyValue> = {
  encode(message: KeyValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    if (message.type !== 0) {
      writer.uint32(24).int32(message.type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KeyValue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeyValue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<KeyValue>, I>>(base?: I): KeyValue {
    return KeyValue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KeyValue>, I>>(object: I): KeyValue {
    const message = createBaseKeyValue();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    message.type = object.type ?? 0;
    return message;
  },
};

function createBaseExternalServiceInfo(): ExternalServiceInfo {
  return { header: undefined, type: 0, statusCode: 0, error: false, warning: false, states: [] };
}

export const ExternalServiceInfo: MessageFns<ExternalServiceInfo> = {
  encode(message: ExternalServiceInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    if (message.statusCode !== 0) {
      writer.uint32(24).uint32(message.statusCode);
    }
    if (message.error !== false) {
      writer.uint32(32).bool(message.error);
    }
    if (message.warning !== false) {
      writer.uint32(40).bool(message.warning);
    }
    for (const v of message.states) {
      KeyValue.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExternalServiceInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExternalServiceInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.statusCode = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.error = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.warning = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.states.push(KeyValue.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ExternalServiceInfo>, I>>(base?: I): ExternalServiceInfo {
    return ExternalServiceInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExternalServiceInfo>, I>>(object: I): ExternalServiceInfo {
    const message = createBaseExternalServiceInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.type = object.type ?? 0;
    message.statusCode = object.statusCode ?? 0;
    message.error = object.error ?? false;
    message.warning = object.warning ?? false;
    message.states = object.states?.map((e) => KeyValue.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFeature(): Feature {
  return { header: undefined, features: [], type: 0, dimmension: new Uint8Array(0) };
}

export const Feature: MessageFns<Feature> = {
  encode(message: Feature, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.features) {
      writer.float(v);
    }
    writer.join();
    if (message.type !== 0) {
      writer.uint32(24).uint32(message.type);
    }
    if (message.dimmension.length !== 0) {
      writer.uint32(34).bytes(message.dimmension);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Feature {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFeature();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag === 21) {
            message.features.push(reader.float());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.features.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.type = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.dimmension = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Feature>, I>>(base?: I): Feature {
    return Feature.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Feature>, I>>(object: I): Feature {
    const message = createBaseFeature();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.features = object.features?.map((e) => e) || [];
    message.type = object.type ?? 0;
    message.dimmension = object.dimmension ?? new Uint8Array(0);
    return message;
  },
};

function createBaseFreespacePoint(): FreespacePoint {
  return { distance: 0, yaw: 0, probability: 0 };
}

export const FreespacePoint: MessageFns<FreespacePoint> = {
  encode(message: FreespacePoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.distance !== 0) {
      writer.uint32(13).float(message.distance);
    }
    if (message.yaw !== 0) {
      writer.uint32(21).float(message.yaw);
    }
    if (message.probability !== 0) {
      writer.uint32(29).float(message.probability);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FreespacePoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFreespacePoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.distance = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.yaw = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.probability = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<FreespacePoint>, I>>(base?: I): FreespacePoint {
    return FreespacePoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FreespacePoint>, I>>(object: I): FreespacePoint {
    const message = createBaseFreespacePoint();
    message.distance = object.distance ?? 0;
    message.yaw = object.yaw ?? 0;
    message.probability = object.probability ?? 0;
    return message;
  },
};

function createBaseFreespace(): Freespace {
  return {
    header: undefined,
    type: 0,
    resolution: 0,
    width: 0,
    height: 0,
    origin: undefined,
    data: new Uint8Array(0),
    points: [],
    outer: undefined,
    inners: [],
  };
}

export const Freespace: MessageFns<Freespace> = {
  encode(message: Freespace, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.type !== 0) {
      writer.uint32(16).uint32(message.type);
    }
    if (message.resolution !== 0) {
      writer.uint32(29).float(message.resolution);
    }
    if (message.width !== 0) {
      writer.uint32(32).uint32(message.width);
    }
    if (message.height !== 0) {
      writer.uint32(40).uint32(message.height);
    }
    if (message.origin !== undefined) {
      Pose.encode(message.origin, writer.uint32(50).fork()).join();
    }
    if (message.data.length !== 0) {
      writer.uint32(58).bytes(message.data);
    }
    for (const v of message.points) {
      FreespacePoint.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.outer !== undefined) {
      Polygon.encode(message.outer, writer.uint32(74).fork()).join();
    }
    for (const v of message.inners) {
      Polygon.encode(v!, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Freespace {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFreespace();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.resolution = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.width = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.height = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.origin = Pose.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.data = reader.bytes();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.points.push(FreespacePoint.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.outer = Polygon.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.inners.push(Polygon.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Freespace>, I>>(base?: I): Freespace {
    return Freespace.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Freespace>, I>>(object: I): Freespace {
    const message = createBaseFreespace();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.type = object.type ?? 0;
    message.resolution = object.resolution ?? 0;
    message.width = object.width ?? 0;
    message.height = object.height ?? 0;
    message.origin = (object.origin !== undefined && object.origin !== null)
      ? Pose.fromPartial(object.origin)
      : undefined;
    message.data = object.data ?? new Uint8Array(0);
    message.points = object.points?.map((e) => FreespacePoint.fromPartial(e)) || [];
    message.outer = (object.outer !== undefined && object.outer !== null)
      ? Polygon.fromPartial(object.outer)
      : undefined;
    message.inners = object.inners?.map((e) => Polygon.fromPartial(e)) || [];
    return message;
  },
};

function createBaseKeyValueArray(): KeyValueArray {
  return { header: undefined, uuid: "", description: "", list: [] };
}

export const KeyValueArray: MessageFns<KeyValueArray> = {
  encode(message: KeyValueArray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.uuid !== "") {
      writer.uint32(18).string(message.uuid);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.list) {
      KeyValue.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KeyValueArray {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeyValueArray();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.list.push(KeyValue.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<KeyValueArray>, I>>(base?: I): KeyValueArray {
    return KeyValueArray.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KeyValueArray>, I>>(object: I): KeyValueArray {
    const message = createBaseKeyValueArray();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.uuid = object.uuid ?? "";
    message.description = object.description ?? "";
    message.list = object.list?.map((e) => KeyValue.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLanePath(): LanePath {
  return { path: [] };
}

export const LanePath: MessageFns<LanePath> = {
  encode(message: LanePath, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.path) {
      Relation.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LanePath {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanePath();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path.push(Relation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<LanePath>, I>>(base?: I): LanePath {
    return LanePath.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LanePath>, I>>(object: I): LanePath {
    const message = createBaseLanePath();
    message.path = object.path?.map((e) => Relation.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLanelet(): Lanelet {
  return {
    id: 0,
    type: 0,
    oneWay: false,
    leftBoundary: [],
    leftBoundaryType: 0,
    leftBoundarySubtype: 0,
    rightBoundary: [],
    rightBoundaryType: 0,
    rightBoundarySubtype: 0,
    centerLine: [],
    regulatoryElements: [],
    relationFrom: [],
    relationTo: [],
  };
}

export const Lanelet: MessageFns<Lanelet> = {
  encode(message: Lanelet, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    if (message.oneWay !== false) {
      writer.uint32(24).bool(message.oneWay);
    }
    for (const v of message.leftBoundary) {
      Point.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.leftBoundaryType !== 0) {
      writer.uint32(40).uint32(message.leftBoundaryType);
    }
    if (message.leftBoundarySubtype !== 0) {
      writer.uint32(48).uint32(message.leftBoundarySubtype);
    }
    for (const v of message.rightBoundary) {
      Point.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.rightBoundaryType !== 0) {
      writer.uint32(64).uint32(message.rightBoundaryType);
    }
    if (message.rightBoundarySubtype !== 0) {
      writer.uint32(72).uint32(message.rightBoundarySubtype);
    }
    for (const v of message.centerLine) {
      Point.encode(v!, writer.uint32(82).fork()).join();
    }
    for (const v of message.regulatoryElements) {
      RegulatoryElement.encode(v!, writer.uint32(90).fork()).join();
    }
    for (const v of message.relationFrom) {
      Relation.encode(v!, writer.uint32(98).fork()).join();
    }
    for (const v of message.relationTo) {
      Relation.encode(v!, writer.uint32(106).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Lanelet {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanelet();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.oneWay = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.leftBoundary.push(Point.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.leftBoundaryType = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.leftBoundarySubtype = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.rightBoundary.push(Point.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.rightBoundaryType = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.rightBoundarySubtype = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.centerLine.push(Point.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.regulatoryElements.push(RegulatoryElement.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.relationFrom.push(Relation.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.relationTo.push(Relation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Lanelet>, I>>(base?: I): Lanelet {
    return Lanelet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Lanelet>, I>>(object: I): Lanelet {
    const message = createBaseLanelet();
    message.id = object.id ?? 0;
    message.type = object.type ?? 0;
    message.oneWay = object.oneWay ?? false;
    message.leftBoundary = object.leftBoundary?.map((e) => Point.fromPartial(e)) || [];
    message.leftBoundaryType = object.leftBoundaryType ?? 0;
    message.leftBoundarySubtype = object.leftBoundarySubtype ?? 0;
    message.rightBoundary = object.rightBoundary?.map((e) => Point.fromPartial(e)) || [];
    message.rightBoundaryType = object.rightBoundaryType ?? 0;
    message.rightBoundarySubtype = object.rightBoundarySubtype ?? 0;
    message.centerLine = object.centerLine?.map((e) => Point.fromPartial(e)) || [];
    message.regulatoryElements = object.regulatoryElements?.map((e) => RegulatoryElement.fromPartial(e)) || [];
    message.relationFrom = object.relationFrom?.map((e) => Relation.fromPartial(e)) || [];
    message.relationTo = object.relationTo?.map((e) => Relation.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMission(): Mission {
  return { header: undefined, mission: 0, subMission: "" };
}

export const Mission: MessageFns<Mission> = {
  encode(message: Mission, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.mission !== 0) {
      writer.uint32(16).int32(message.mission);
    }
    if (message.subMission !== "") {
      writer.uint32(26).string(message.subMission);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Mission {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMission();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.mission = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.subMission = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Mission>, I>>(base?: I): Mission {
    return Mission.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Mission>, I>>(object: I): Mission {
    const message = createBaseMission();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.mission = object.mission ?? 0;
    message.subMission = object.subMission ?? "";
    return message;
  },
};

function createBaseMissionCmd(): MissionCmd {
  return { header: undefined, type: 0, subType: "" };
}

export const MissionCmd: MessageFns<MissionCmd> = {
  encode(message: MissionCmd, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    if (message.subType !== "") {
      writer.uint32(26).string(message.subType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MissionCmd {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionCmd();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.subType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<MissionCmd>, I>>(base?: I): MissionCmd {
    return MissionCmd.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionCmd>, I>>(object: I): MissionCmd {
    const message = createBaseMissionCmd();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.type = object.type ?? 0;
    message.subType = object.subType ?? "";
    return message;
  },
};

function createBaseMrmCmd(): MrmCmd {
  return { header: undefined, mode: 0, warningLevel: 0 };
}

export const MrmCmd: MessageFns<MrmCmd> = {
  encode(message: MrmCmd, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.mode !== 0) {
      writer.uint32(16).int32(message.mode);
    }
    if (message.warningLevel !== 0) {
      writer.uint32(24).uint32(message.warningLevel);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MrmCmd {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMrmCmd();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.warningLevel = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<MrmCmd>, I>>(base?: I): MrmCmd {
    return MrmCmd.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MrmCmd>, I>>(object: I): MrmCmd {
    const message = createBaseMrmCmd();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.mode = object.mode ?? 0;
    message.warningLevel = object.warningLevel ?? 0;
    return message;
  },
};

function createBaseMultiFunctionSwitch(): MultiFunctionSwitch {
  return { mfs: 0 };
}

export const MultiFunctionSwitch: MessageFns<MultiFunctionSwitch> = {
  encode(message: MultiFunctionSwitch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mfs !== 0) {
      writer.uint32(8).int32(message.mfs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MultiFunctionSwitch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultiFunctionSwitch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.mfs = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<MultiFunctionSwitch>, I>>(base?: I): MultiFunctionSwitch {
    return MultiFunctionSwitch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MultiFunctionSwitch>, I>>(object: I): MultiFunctionSwitch {
    const message = createBaseMultiFunctionSwitch();
    message.mfs = object.mfs ?? 0;
    return message;
  },
};

function createBaseSize(): Size {
  return { header: undefined, size: [], type: 0 };
}

export const Size: MessageFns<Size> = {
  encode(message: Size, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.size) {
      writer.float(v);
    }
    writer.join();
    if (message.type !== 0) {
      writer.uint32(24).int32(message.type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Size {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSize();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag === 21) {
            message.size.push(reader.float());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.size.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Size>, I>>(base?: I): Size {
    return Size.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Size>, I>>(object: I): Size {
    const message = createBaseSize();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.size = object.size?.map((e) => e) || [];
    message.type = object.type ?? 0;
    return message;
  },
};

function createBaseTrack(): Track {
  return {
    header: undefined,
    id: 0,
    state: [],
    stateDescriptor: [],
    covariance: [],
    initialTime: undefined,
    updateTime: undefined,
    updateCount: 0,
    gate: [],
    status: 0,
    model: 0,
  };
}

export const Track: MessageFns<Track> = {
  encode(message: Track, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.id !== 0) {
      writer.uint32(16).int64(message.id);
    }
    writer.uint32(26).fork();
    for (const v of message.state) {
      writer.double(v);
    }
    writer.join();
    for (const v of message.stateDescriptor) {
      writer.uint32(34).string(v!);
    }
    writer.uint32(42).fork();
    for (const v of message.covariance) {
      writer.double(v);
    }
    writer.join();
    if (message.initialTime !== undefined) {
      Header.encode(message.initialTime, writer.uint32(50).fork()).join();
    }
    if (message.updateTime !== undefined) {
      Header.encode(message.updateTime, writer.uint32(58).fork()).join();
    }
    if (message.updateCount !== 0) {
      writer.uint32(65).double(message.updateCount);
    }
    writer.uint32(74).fork();
    for (const v of message.gate) {
      writer.double(v);
    }
    writer.join();
    if (message.status !== 0) {
      writer.uint32(80).uint32(message.status);
    }
    if (message.model !== 0) {
      writer.uint32(88).uint32(message.model);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Track {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrack();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.id = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag === 25) {
            message.state.push(reader.double());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.state.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.stateDescriptor.push(reader.string());
          continue;
        }
        case 5: {
          if (tag === 41) {
            message.covariance.push(reader.double());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.covariance.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.initialTime = Header.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updateTime = Header.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.updateCount = reader.double();
          continue;
        }
        case 9: {
          if (tag === 73) {
            message.gate.push(reader.double());

            continue;
          }

          if (tag === 74) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.gate.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.status = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.model = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Track>, I>>(base?: I): Track {
    return Track.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Track>, I>>(object: I): Track {
    const message = createBaseTrack();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.id = object.id ?? 0;
    message.state = object.state?.map((e) => e) || [];
    message.stateDescriptor = object.stateDescriptor?.map((e) => e) || [];
    message.covariance = object.covariance?.map((e) => e) || [];
    message.initialTime = (object.initialTime !== undefined && object.initialTime !== null)
      ? Header.fromPartial(object.initialTime)
      : undefined;
    message.updateTime = (object.updateTime !== undefined && object.updateTime !== null)
      ? Header.fromPartial(object.updateTime)
      : undefined;
    message.updateCount = object.updateCount ?? 0;
    message.gate = object.gate?.map((e) => e) || [];
    message.status = object.status ?? 0;
    message.model = object.model ?? 0;
    return message;
  },
};

function createBaseObject(): Object {
  return {
    header: undefined,
    odometry: undefined,
    anchor: undefined,
    size: undefined,
    polygon: undefined,
    track: undefined,
    tracklet: [],
    classification: 0,
    level: 0,
    sensor: 0,
    motionState: 0,
    stopCount: 0,
    intent: 0,
    geometry: [],
    feature: undefined,
  };
}

export const Object: MessageFns<Object> = {
  encode(message: Object, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.odometry !== undefined) {
      Odometry.encode(message.odometry, writer.uint32(18).fork()).join();
    }
    if (message.anchor !== undefined) {
      Odometry.encode(message.anchor, writer.uint32(26).fork()).join();
    }
    if (message.size !== undefined) {
      Size.encode(message.size, writer.uint32(34).fork()).join();
    }
    if (message.polygon !== undefined) {
      Polygon.encode(message.polygon, writer.uint32(42).fork()).join();
    }
    if (message.track !== undefined) {
      Track.encode(message.track, writer.uint32(50).fork()).join();
    }
    for (const v of message.tracklet) {
      Odometry.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.classification !== 0) {
      writer.uint32(64).int32(message.classification);
    }
    if (message.level !== 0) {
      writer.uint32(72).int32(message.level);
    }
    if (message.sensor !== 0) {
      writer.uint32(80).uint32(message.sensor);
    }
    if (message.motionState !== 0) {
      writer.uint32(88).int32(message.motionState);
    }
    if (message.stopCount !== 0) {
      writer.uint32(96).uint32(message.stopCount);
    }
    if (message.intent !== 0) {
      writer.uint32(104).int32(message.intent);
    }
    for (const v of message.geometry) {
      Point.encode(v!, writer.uint32(114).fork()).join();
    }
    if (message.feature !== undefined) {
      Feature.encode(message.feature, writer.uint32(122).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Object {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObject();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.odometry = Odometry.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.anchor = Odometry.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.size = Size.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.polygon = Polygon.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.track = Track.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.tracklet.push(Odometry.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.classification = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.level = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.sensor = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.motionState = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.stopCount = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.intent = reader.int32() as any;
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.geometry.push(Point.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.feature = Feature.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Object>, I>>(base?: I): Object {
    return Object.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Object>, I>>(object: I): Object {
    const message = createBaseObject();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.odometry = (object.odometry !== undefined && object.odometry !== null)
      ? Odometry.fromPartial(object.odometry)
      : undefined;
    message.anchor = (object.anchor !== undefined && object.anchor !== null)
      ? Odometry.fromPartial(object.anchor)
      : undefined;
    message.size = (object.size !== undefined && object.size !== null) ? Size.fromPartial(object.size) : undefined;
    message.polygon = (object.polygon !== undefined && object.polygon !== null)
      ? Polygon.fromPartial(object.polygon)
      : undefined;
    message.track = (object.track !== undefined && object.track !== null) ? Track.fromPartial(object.track) : undefined;
    message.tracklet = object.tracklet?.map((e) => Odometry.fromPartial(e)) || [];
    message.classification = object.classification ?? 0;
    message.level = object.level ?? 0;
    message.sensor = object.sensor ?? 0;
    message.motionState = object.motionState ?? 0;
    message.stopCount = object.stopCount ?? 0;
    message.intent = object.intent ?? 0;
    message.geometry = object.geometry?.map((e) => Point.fromPartial(e)) || [];
    message.feature = (object.feature !== undefined && object.feature !== null)
      ? Feature.fromPartial(object.feature)
      : undefined;
    return message;
  },
};

function createBaseObjectArray(): ObjectArray {
  return { header: undefined, objects: [] };
}

export const ObjectArray: MessageFns<ObjectArray> = {
  encode(message: ObjectArray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    for (const v of message.objects) {
      Object.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ObjectArray {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObjectArray();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.objects.push(Object.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ObjectArray>, I>>(base?: I): ObjectArray {
    return ObjectArray.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ObjectArray>, I>>(object: I): ObjectArray {
    const message = createBaseObjectArray();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.objects = object.objects?.map((e) => Object.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOperationSw(): OperationSw {
  return { header: undefined, operationSw: false, autonomousSw: false, emergencySw: false, activator: 0 };
}

export const OperationSw: MessageFns<OperationSw> = {
  encode(message: OperationSw, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.operationSw !== false) {
      writer.uint32(16).bool(message.operationSw);
    }
    if (message.autonomousSw !== false) {
      writer.uint32(24).bool(message.autonomousSw);
    }
    if (message.emergencySw !== false) {
      writer.uint32(32).bool(message.emergencySw);
    }
    if (message.activator !== 0) {
      writer.uint32(40).int32(message.activator);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OperationSw {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOperationSw();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.operationSw = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.autonomousSw = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.emergencySw = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.activator = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<OperationSw>, I>>(base?: I): OperationSw {
    return OperationSw.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OperationSw>, I>>(object: I): OperationSw {
    const message = createBaseOperationSw();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.operationSw = object.operationSw ?? false;
    message.autonomousSw = object.autonomousSw ?? false;
    message.emergencySw = object.emergencySw ?? false;
    message.activator = object.activator ?? 0;
    return message;
  },
};

function createBasePathNode(): PathNode {
  return { pose: undefined, dir: 0 };
}

export const PathNode: MessageFns<PathNode> = {
  encode(message: PathNode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pose !== undefined) {
      Pose.encode(message.pose, writer.uint32(10).fork()).join();
    }
    if (message.dir !== 0) {
      writer.uint32(16).int32(message.dir);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PathNode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePathNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pose = Pose.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.dir = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<PathNode>, I>>(base?: I): PathNode {
    return PathNode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PathNode>, I>>(object: I): PathNode {
    const message = createBasePathNode();
    message.pose = (object.pose !== undefined && object.pose !== null) ? Pose.fromPartial(object.pose) : undefined;
    message.dir = object.dir ?? 0;
    return message;
  },
};

function createBasePath(): Path {
  return { header: undefined, nodes: [], behavior: 0, subtype: 0, state: 0 };
}

export const Path: MessageFns<Path> = {
  encode(message: Path, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    for (const v of message.nodes) {
      PathNode.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.behavior !== 0) {
      writer.uint32(24).int32(message.behavior);
    }
    if (message.subtype !== 0) {
      writer.uint32(32).int32(message.subtype);
    }
    if (message.state !== 0) {
      writer.uint32(40).int32(message.state);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Path {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePath();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodes.push(PathNode.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.behavior = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.subtype = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Path>, I>>(base?: I): Path {
    return Path.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Path>, I>>(object: I): Path {
    const message = createBasePath();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.nodes = object.nodes?.map((e) => PathNode.fromPartial(e)) || [];
    message.behavior = object.behavior ?? 0;
    message.subtype = object.subtype ?? 0;
    message.state = object.state ?? 0;
    return message;
  },
};

function createBaseRoute(): Route {
  return { route: [] };
}

export const Route: MessageFns<Route> = {
  encode(message: Route, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.route) {
      Relation.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Route {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoute();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.route.push(Relation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Route>, I>>(base?: I): Route {
    return Route.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Route>, I>>(object: I): Route {
    const message = createBaseRoute();
    message.route = object.route?.map((e) => Relation.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRoad(): Road {
  return { header: undefined, route: undefined, path: undefined, lanes: [], areas: [], goal: undefined };
}

export const Road: MessageFns<Road> = {
  encode(message: Road, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.route !== undefined) {
      Route.encode(message.route, writer.uint32(18).fork()).join();
    }
    if (message.path !== undefined) {
      LanePath.encode(message.path, writer.uint32(26).fork()).join();
    }
    for (const v of message.lanes) {
      Lanelet.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.areas) {
      Area.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.goal !== undefined) {
      Pose.encode(message.goal, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Road {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoad();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.route = Route.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.path = LanePath.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.lanes.push(Lanelet.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.areas.push(Area.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.goal = Pose.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Road>, I>>(base?: I): Road {
    return Road.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Road>, I>>(object: I): Road {
    const message = createBaseRoad();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.route = (object.route !== undefined && object.route !== null) ? Route.fromPartial(object.route) : undefined;
    message.path = (object.path !== undefined && object.path !== null) ? LanePath.fromPartial(object.path) : undefined;
    message.lanes = object.lanes?.map((e) => Lanelet.fromPartial(e)) || [];
    message.areas = object.areas?.map((e) => Area.fromPartial(e)) || [];
    message.goal = (object.goal !== undefined && object.goal !== null) ? Pose.fromPartial(object.goal) : undefined;
    return message;
  },
};

function createBaseSpeedProfileNode(): SpeedProfileNode {
  return { distance: 0, speed: 0, time: 0, direction: 0 };
}

export const SpeedProfileNode: MessageFns<SpeedProfileNode> = {
  encode(message: SpeedProfileNode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.distance !== 0) {
      writer.uint32(13).float(message.distance);
    }
    if (message.speed !== 0) {
      writer.uint32(21).float(message.speed);
    }
    if (message.time !== 0) {
      writer.uint32(29).float(message.time);
    }
    if (message.direction !== 0) {
      writer.uint32(32).int32(message.direction);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpeedProfileNode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpeedProfileNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.distance = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.speed = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.time = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.direction = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SpeedProfileNode>, I>>(base?: I): SpeedProfileNode {
    return SpeedProfileNode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpeedProfileNode>, I>>(object: I): SpeedProfileNode {
    const message = createBaseSpeedProfileNode();
    message.distance = object.distance ?? 0;
    message.speed = object.speed ?? 0;
    message.time = object.time ?? 0;
    message.direction = object.direction ?? 0;
    return message;
  },
};

function createBaseSpeedProfile(): SpeedProfile {
  return { header: undefined, speedLimit: 0, points: [], stopLine: [] };
}

export const SpeedProfile: MessageFns<SpeedProfile> = {
  encode(message: SpeedProfile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.speedLimit !== 0) {
      writer.uint32(21).float(message.speedLimit);
    }
    for (const v of message.points) {
      SpeedProfileNode.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.stopLine) {
      Point.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpeedProfile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpeedProfile();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.speedLimit = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.points.push(SpeedProfileNode.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.stopLine.push(Point.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SpeedProfile>, I>>(base?: I): SpeedProfile {
    return SpeedProfile.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpeedProfile>, I>>(object: I): SpeedProfile {
    const message = createBaseSpeedProfile();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.speedLimit = object.speedLimit ?? 0;
    message.points = object.points?.map((e) => SpeedProfileNode.fromPartial(e)) || [];
    message.stopLine = object.stopLine?.map((e) => Point.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSystemCmd(): SystemCmd {
  return { header: undefined, command: 0 };
}

export const SystemCmd: MessageFns<SystemCmd> = {
  encode(message: SystemCmd, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.command !== 0) {
      writer.uint32(16).int32(message.command);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SystemCmd {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSystemCmd();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.command = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SystemCmd>, I>>(base?: I): SystemCmd {
    return SystemCmd.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SystemCmd>, I>>(object: I): SystemCmd {
    const message = createBaseSystemCmd();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.command = object.command ?? 0;
    return message;
  },
};

function createBaseTextNotify(): TextNotify {
  return { header: undefined, uuid: "", author: "", createdAt: "", title: "", text: "", format: 0, urgentLevel: 0 };
}

export const TextNotify: MessageFns<TextNotify> = {
  encode(message: TextNotify, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.uuid !== "") {
      writer.uint32(18).string(message.uuid);
    }
    if (message.author !== "") {
      writer.uint32(26).string(message.author);
    }
    if (message.createdAt !== "") {
      writer.uint32(34).string(message.createdAt);
    }
    if (message.title !== "") {
      writer.uint32(42).string(message.title);
    }
    if (message.text !== "") {
      writer.uint32(50).string(message.text);
    }
    if (message.format !== 0) {
      writer.uint32(56).int32(message.format);
    }
    if (message.urgentLevel !== 0) {
      writer.uint32(64).int32(message.urgentLevel);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TextNotify {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTextNotify();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.author = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.format = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.urgentLevel = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TextNotify>, I>>(base?: I): TextNotify {
    return TextNotify.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TextNotify>, I>>(object: I): TextNotify {
    const message = createBaseTextNotify();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.uuid = object.uuid ?? "";
    message.author = object.author ?? "";
    message.createdAt = object.createdAt ?? "";
    message.title = object.title ?? "";
    message.text = object.text ?? "";
    message.format = object.format ?? 0;
    message.urgentLevel = object.urgentLevel ?? 0;
    return message;
  },
};

function createBaseTrafficLight(): TrafficLight {
  return {
    header: undefined,
    state: 0,
    stateProbability: 0,
    type: 0,
    isIts: false,
    intersectionId: 0,
    groupId: 0,
    endTime: 0,
    level: 0,
    trackId: 0,
    pose: undefined,
  };
}

export const TrafficLight: MessageFns<TrafficLight> = {
  encode(message: TrafficLight, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.state !== 0) {
      writer.uint32(16).int32(message.state);
    }
    if (message.stateProbability !== 0) {
      writer.uint32(29).float(message.stateProbability);
    }
    if (message.type !== 0) {
      writer.uint32(32).int32(message.type);
    }
    if (message.isIts !== false) {
      writer.uint32(40).bool(message.isIts);
    }
    if (message.intersectionId !== 0) {
      writer.uint32(48).int64(message.intersectionId);
    }
    if (message.groupId !== 0) {
      writer.uint32(56).int64(message.groupId);
    }
    if (message.endTime !== 0) {
      writer.uint32(69).float(message.endTime);
    }
    if (message.level !== 0) {
      writer.uint32(72).int32(message.level);
    }
    if (message.trackId !== 0) {
      writer.uint32(80).int64(message.trackId);
    }
    if (message.pose !== undefined) {
      PoseWithCovariance.encode(message.pose, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TrafficLight {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrafficLight();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.stateProbability = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isIts = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.intersectionId = longToNumber(reader.int64());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.groupId = longToNumber(reader.int64());
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.endTime = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.level = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.trackId = longToNumber(reader.int64());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.pose = PoseWithCovariance.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TrafficLight>, I>>(base?: I): TrafficLight {
    return TrafficLight.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrafficLight>, I>>(object: I): TrafficLight {
    const message = createBaseTrafficLight();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.state = object.state ?? 0;
    message.stateProbability = object.stateProbability ?? 0;
    message.type = object.type ?? 0;
    message.isIts = object.isIts ?? false;
    message.intersectionId = object.intersectionId ?? 0;
    message.groupId = object.groupId ?? 0;
    message.endTime = object.endTime ?? 0;
    message.level = object.level ?? 0;
    message.trackId = object.trackId ?? 0;
    message.pose = (object.pose !== undefined && object.pose !== null)
      ? PoseWithCovariance.fromPartial(object.pose)
      : undefined;
    return message;
  },
};

function createBaseTrafficLightArray(): TrafficLightArray {
  return { header: undefined, trafficLights: [] };
}

export const TrafficLightArray: MessageFns<TrafficLightArray> = {
  encode(message: TrafficLightArray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    for (const v of message.trafficLights) {
      TrafficLight.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TrafficLightArray {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrafficLightArray();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.trafficLights.push(TrafficLight.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TrafficLightArray>, I>>(base?: I): TrafficLightArray {
    return TrafficLightArray.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrafficLightArray>, I>>(object: I): TrafficLightArray {
    const message = createBaseTrafficLightArray();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.trafficLights = object.trafficLights?.map((e) => TrafficLight.fromPartial(e)) || [];
    return message;
  },
};

function createBaseWgs84(): Wgs84 {
  return { latitude: 0, longitude: 0, height: 0, heading: 0, status: 0 };
}

export const Wgs84: MessageFns<Wgs84> = {
  encode(message: Wgs84, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.latitude !== 0) {
      writer.uint32(9).double(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(17).double(message.longitude);
    }
    if (message.height !== 0) {
      writer.uint32(29).float(message.height);
    }
    if (message.heading !== 0) {
      writer.uint32(37).float(message.heading);
    }
    if (message.status !== 0) {
      writer.uint32(40).int32(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Wgs84 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWgs84();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.height = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.heading = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Wgs84>, I>>(base?: I): Wgs84 {
    return Wgs84.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Wgs84>, I>>(object: I): Wgs84 {
    const message = createBaseWgs84();
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    message.height = object.height ?? 0;
    message.heading = object.heading ?? 0;
    message.status = object.status ?? 0;
    return message;
  },
};

function createBaseVehicleResponse(): VehicleResponse {
  return { header: undefined, response: 0, gnss: undefined };
}

export const VehicleResponse: MessageFns<VehicleResponse> = {
  encode(message: VehicleResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.response !== 0) {
      writer.uint32(16).int32(message.response);
    }
    if (message.gnss !== undefined) {
      Wgs84.encode(message.gnss, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VehicleResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVehicleResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.response = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.gnss = Wgs84.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<VehicleResponse>, I>>(base?: I): VehicleResponse {
    return VehicleResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VehicleResponse>, I>>(object: I): VehicleResponse {
    const message = createBaseVehicleResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.response = object.response ?? 0;
    message.gnss = (object.gnss !== undefined && object.gnss !== null) ? Wgs84.fromPartial(object.gnss) : undefined;
    return message;
  },
};

function createBaseVehicleState(): VehicleState {
  return {
    header: undefined,
    odometry: undefined,
    gnss: undefined,
    reference: undefined,
    speed: 0,
    longitudinalAcceleration: 0,
    lateralAcceleration: 0,
    steeringAngle: 0,
    gear: undefined,
    turnSignal: undefined,
    mfs: undefined,
    ignition: undefined,
    charging: undefined,
    pedal: undefined,
  };
}

export const VehicleState: MessageFns<VehicleState> = {
  encode(message: VehicleState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.odometry !== undefined) {
      Odometry.encode(message.odometry, writer.uint32(18).fork()).join();
    }
    if (message.gnss !== undefined) {
      Wgs84.encode(message.gnss, writer.uint32(26).fork()).join();
    }
    if (message.reference !== undefined) {
      Wgs84.encode(message.reference, writer.uint32(34).fork()).join();
    }
    if (message.speed !== 0) {
      writer.uint32(45).float(message.speed);
    }
    if (message.longitudinalAcceleration !== 0) {
      writer.uint32(53).float(message.longitudinalAcceleration);
    }
    if (message.lateralAcceleration !== 0) {
      writer.uint32(61).float(message.lateralAcceleration);
    }
    if (message.steeringAngle !== 0) {
      writer.uint32(69).float(message.steeringAngle);
    }
    if (message.gear !== undefined) {
      Gear.encode(message.gear, writer.uint32(74).fork()).join();
    }
    if (message.turnSignal !== undefined) {
      TurnSignal.encode(message.turnSignal, writer.uint32(82).fork()).join();
    }
    if (message.mfs !== undefined) {
      MultiFunctionSwitch.encode(message.mfs, writer.uint32(90).fork()).join();
    }
    if (message.ignition !== undefined) {
      IgnitionInfo.encode(message.ignition, writer.uint32(98).fork()).join();
    }
    if (message.charging !== undefined) {
      ChargingInfo.encode(message.charging, writer.uint32(106).fork()).join();
    }
    if (message.pedal !== undefined) {
      LongitudinalInfo.encode(message.pedal, writer.uint32(114).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VehicleState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVehicleState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.odometry = Odometry.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.gnss = Wgs84.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.reference = Wgs84.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.speed = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.longitudinalAcceleration = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.lateralAcceleration = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.steeringAngle = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.gear = Gear.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.turnSignal = TurnSignal.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.mfs = MultiFunctionSwitch.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.ignition = IgnitionInfo.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.charging = ChargingInfo.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.pedal = LongitudinalInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<VehicleState>, I>>(base?: I): VehicleState {
    return VehicleState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VehicleState>, I>>(object: I): VehicleState {
    const message = createBaseVehicleState();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.odometry = (object.odometry !== undefined && object.odometry !== null)
      ? Odometry.fromPartial(object.odometry)
      : undefined;
    message.gnss = (object.gnss !== undefined && object.gnss !== null) ? Wgs84.fromPartial(object.gnss) : undefined;
    message.reference = (object.reference !== undefined && object.reference !== null)
      ? Wgs84.fromPartial(object.reference)
      : undefined;
    message.speed = object.speed ?? 0;
    message.longitudinalAcceleration = object.longitudinalAcceleration ?? 0;
    message.lateralAcceleration = object.lateralAcceleration ?? 0;
    message.steeringAngle = object.steeringAngle ?? 0;
    message.gear = (object.gear !== undefined && object.gear !== null) ? Gear.fromPartial(object.gear) : undefined;
    message.turnSignal = (object.turnSignal !== undefined && object.turnSignal !== null)
      ? TurnSignal.fromPartial(object.turnSignal)
      : undefined;
    message.mfs = (object.mfs !== undefined && object.mfs !== null)
      ? MultiFunctionSwitch.fromPartial(object.mfs)
      : undefined;
    message.ignition = (object.ignition !== undefined && object.ignition !== null)
      ? IgnitionInfo.fromPartial(object.ignition)
      : undefined;
    message.charging = (object.charging !== undefined && object.charging !== null)
      ? ChargingInfo.fromPartial(object.charging)
      : undefined;
    message.pedal = (object.pedal !== undefined && object.pedal !== null)
      ? LongitudinalInfo.fromPartial(object.pedal)
      : undefined;
    return message;
  },
};

function createBaseWaypoint(): Waypoint {
  return { header: undefined, point: undefined };
}

export const Waypoint: MessageFns<Waypoint> = {
  encode(message: Waypoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.point !== undefined) {
      Wgs84.encode(message.point, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Waypoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaypoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.point = Wgs84.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Waypoint>, I>>(base?: I): Waypoint {
    return Waypoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Waypoint>, I>>(object: I): Waypoint {
    const message = createBaseWaypoint();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.point = (object.point !== undefined && object.point !== null) ? Wgs84.fromPartial(object.point) : undefined;
    return message;
  },
};

function createBaseWaypoints(): Waypoints {
  return { header: undefined, numPoints: 0, points: [] };
}

export const Waypoints: MessageFns<Waypoints> = {
  encode(message: Waypoints, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.numPoints !== 0) {
      writer.uint32(16).uint32(message.numPoints);
    }
    for (const v of message.points) {
      Waypoint.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Waypoints {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaypoints();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.numPoints = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.points.push(Waypoint.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Waypoints>, I>>(base?: I): Waypoints {
    return Waypoints.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Waypoints>, I>>(object: I): Waypoints {
    const message = createBaseWaypoints();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.numPoints = object.numPoints ?? 0;
    message.points = object.points?.map((e) => Waypoint.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBrainStatus(): BrainStatus {
  return {};
}

export const BrainStatus: MessageFns<BrainStatus> = {
  encode(_: BrainStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BrainStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBrainStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<BrainStatus>, I>>(base?: I): BrainStatus {
    return BrainStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BrainStatus>, I>>(_: I): BrainStatus {
    const message = createBaseBrainStatus();
    return message;
  },
};

function createBaseChargingCmd(): ChargingCmd {
  return { header: undefined, doorCmd: 0 };
}

export const ChargingCmd: MessageFns<ChargingCmd> = {
  encode(message: ChargingCmd, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.doorCmd !== 0) {
      writer.uint32(16).int32(message.doorCmd);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChargingCmd {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChargingCmd();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.doorCmd = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ChargingCmd>, I>>(base?: I): ChargingCmd {
    return ChargingCmd.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChargingCmd>, I>>(object: I): ChargingCmd {
    const message = createBaseChargingCmd();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.doorCmd = object.doorCmd ?? 0;
    return message;
  },
};

function createBaseIgnitionCmd(): IgnitionCmd {
  return { header: undefined, request: 0 };
}

export const IgnitionCmd: MessageFns<IgnitionCmd> = {
  encode(message: IgnitionCmd, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.request !== 0) {
      writer.uint32(16).int32(message.request);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IgnitionCmd {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIgnitionCmd();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.request = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<IgnitionCmd>, I>>(base?: I): IgnitionCmd {
    return IgnitionCmd.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IgnitionCmd>, I>>(object: I): IgnitionCmd {
    const message = createBaseIgnitionCmd();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.request = object.request ?? 0;
    return message;
  },
};

function createBaseCanFrame(): CanFrame {
  return {
    header: undefined,
    channel: "",
    description: "",
    id: 0,
    isExtended: false,
    isFd: false,
    isRemote: false,
    isError: false,
    brs: false,
    esi: false,
    dlc: 0,
    data: new Uint8Array(0),
  };
}

export const CanFrame: MessageFns<CanFrame> = {
  encode(message: CanFrame, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.channel !== "") {
      writer.uint32(18).string(message.channel);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.id !== 0) {
      writer.uint32(32).uint32(message.id);
    }
    if (message.isExtended !== false) {
      writer.uint32(40).bool(message.isExtended);
    }
    if (message.isFd !== false) {
      writer.uint32(48).bool(message.isFd);
    }
    if (message.isRemote !== false) {
      writer.uint32(56).bool(message.isRemote);
    }
    if (message.isError !== false) {
      writer.uint32(64).bool(message.isError);
    }
    if (message.brs !== false) {
      writer.uint32(72).bool(message.brs);
    }
    if (message.esi !== false) {
      writer.uint32(80).bool(message.esi);
    }
    if (message.dlc !== 0) {
      writer.uint32(88).uint32(message.dlc);
    }
    if (message.data.length !== 0) {
      writer.uint32(98).bytes(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CanFrame {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCanFrame();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.channel = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isExtended = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.isFd = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.isRemote = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.isError = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.brs = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.esi = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.dlc = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.data = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CanFrame>, I>>(base?: I): CanFrame {
    return CanFrame.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CanFrame>, I>>(object: I): CanFrame {
    const message = createBaseCanFrame();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.channel = object.channel ?? "";
    message.description = object.description ?? "";
    message.id = object.id ?? 0;
    message.isExtended = object.isExtended ?? false;
    message.isFd = object.isFd ?? false;
    message.isRemote = object.isRemote ?? false;
    message.isError = object.isError ?? false;
    message.brs = object.brs ?? false;
    message.esi = object.esi ?? false;
    message.dlc = object.dlc ?? 0;
    message.data = object.data ?? new Uint8Array(0);
    return message;
  },
};

function createBaseEthernetPacket(): EthernetPacket {
  return {
    header: undefined,
    interfaceName: "",
    srcMac: new Uint8Array(0),
    dstMac: new Uint8Array(0),
    etherType: 0,
    payload: new Uint8Array(0),
    vlanId: 0,
  };
}

export const EthernetPacket: MessageFns<EthernetPacket> = {
  encode(message: EthernetPacket, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.interfaceName !== "") {
      writer.uint32(18).string(message.interfaceName);
    }
    if (message.srcMac.length !== 0) {
      writer.uint32(26).bytes(message.srcMac);
    }
    if (message.dstMac.length !== 0) {
      writer.uint32(34).bytes(message.dstMac);
    }
    if (message.etherType !== 0) {
      writer.uint32(40).uint32(message.etherType);
    }
    if (message.payload.length !== 0) {
      writer.uint32(50).bytes(message.payload);
    }
    if (message.vlanId !== 0) {
      writer.uint32(56).uint32(message.vlanId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EthernetPacket {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEthernetPacket();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.interfaceName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.srcMac = reader.bytes();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.dstMac = reader.bytes();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.etherType = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.payload = reader.bytes();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.vlanId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<EthernetPacket>, I>>(base?: I): EthernetPacket {
    return EthernetPacket.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EthernetPacket>, I>>(object: I): EthernetPacket {
    const message = createBaseEthernetPacket();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.interfaceName = object.interfaceName ?? "";
    message.srcMac = object.srcMac ?? new Uint8Array(0);
    message.dstMac = object.dstMac ?? new Uint8Array(0);
    message.etherType = object.etherType ?? 0;
    message.payload = object.payload ?? new Uint8Array(0);
    message.vlanId = object.vlanId ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
